import { css } from '@emotion/react';
import { colors } from '@cimpress/react-components';
export const overviewLabelCss = css `
    color: #8090a2;
    margin-bottom: 40px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
`;
export const mutedTextCss = css `
    color: ${colors.alloy};
`;
export const overviewSectionCss = css `
    padding: 5px;
    margin-bottom: 16px;

    & .table {
        margin-bottom: 0px;
    }
`;
export const productIdCss = css `
    font-weight: 600px;
    padding-right: 5px;
    &::after {
        content: ',';
    }
    &:last-child::after {
        content: '';
    }
`;
export const overviewSectionTitleCss = css `
    padding-bottom: 4px;
    border-bottom: 1px dotted ${colors.shale};
    margin-top: 24px;
    margin-bottom: 16px;
    display: block;
`;
export const methodLabelSimpleCss = css `
    font-weight: 600;
    padding: 0px 3px 0px 3px;
    border: 0px;
    border-left: 2px solid ${colors.info.darkest};
    margin-right: 5px;
    margin-bottom: 5px;
    display: inline-block;
`;
export const receipentValueCss = css `
    word-break: break-word;
    display: block;
    font-weight: 600;
`;
export const actionLabelSimpleCss = css `
    font-weight: 600;
    padding: 0px 3px 0px 3px;
    border: 0px;
    border-left: 2px solid ${colors.info.base};
    margin-right: 5px;
    margin-bottom: 5px;
    display: inline-block;
`;
